import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, API } from "@/lib/api";

const DEFAULTS = {
  qris_mode: "single", qris_image: null, qris_images: {}, support_wa: "6281234567890", wa_channel: "",
  bongkar_otomatis_url: "", live_chat_url: "", telegram_url: "",
  seo_title: "JP STORE | Top Up & Bongkar Chip", seo_description: "JP STORE - Top up dan bongkar chip Royal Dream & Higgs Domino", seo_keywords: "",
  og_image_version: null, marquee_enabled: false, marquee_text: "", marquee_speed: "normal",
};
const SiteSettingsContext = createContext({ ...DEFAULTS, reload: () => {} });

export const ogImageUrl = (v) => (v ? `${API}/og-image?v=${v}` : null);

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const applySeo = (s) => {
  document.title = s.seo_title;
  const img = ogImageUrl(s.og_image_version);
  setMeta("name", "description", s.seo_description);
  setMeta("name", "keywords", s.seo_keywords);
  setMeta("property", "og:title", s.seo_title);
  setMeta("property", "og:description", s.seo_description);
  setMeta("property", "og:type", "website");
  setMeta("property", "og:url", window.location.origin);
  setMeta("property", "og:image", img);
  setMeta("name", "twitter:card", img ? "summary_large_image" : "summary");
};

export const waLink = (number, text) =>
  `https://wa.me/${number}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/public");
      setSettings(data);
    } catch {
      setSettings(DEFAULTS);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    applySeo(settings);
  }, [settings]);

  return (
    <SiteSettingsContext.Provider value={{ ...settings, reload }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
